// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__nD0up","label":"Slider_label__bG0HT","slider":"Slider_slider__8t8mY"};